export default {
  image: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    'div > div > img': {
      minWidth: { xs: '188px', sm: '540px' },
      height: { xs: '186px', sm: '432px' },
    },
    mt: {
      xs: 0,
      md: -5,
    },
  },
  container: {
    gap: {
      md: '0',
      sm: '16px',
    },
  },
  item: {
    paddingRight: {
      xs: '24px',
      xl: '40px',
    },
    paddingTop: {
      xs: '16px',
      xl: '0',
    },
    '&:nth-of-type(2n)': {
      paddingRight: {
        xs: 0,
        xl: '40px',
      },
    },
    '&:nth-of-type(1)': {
      paddingTop: {
        xs: '0',
      },
    },
    '&:nth-of-type(2)': {
      paddingTop: {
        xs: '0',
      },
    },
  },
  value: {
    color: 'kit.text.h',
    marginTop: {
      xs: '32px',
      // xl: '8px',
    },
    marginBottom: {
      xs: '4px',
      xl: '8px',
    },
  },
  itemContainer: (theme) => ({
    [theme.breakpoints.down('sm')]: {
      maxWidth: '270px',
      width: '100%',
    },
  }),
};
